import Vue from 'vue'

import './assets/css'

import { store, router } from './configs'

import './components'
import './directives'
import './services'
import './filters'
import './mixins'
import App from './App'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

let app = new Vue({
  store,
  router,
  ...App
})

Vue.use(VueAnalytics, {
  id: 'UA-21769753-4',
  disableScriptLoader: true,
  router,
  autoTracking: {
    pageviewOnLoad: false
  }
})

app.$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js